import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';

export function createText(
  text: string,
  styleMap: Map<string, string>, // key-value props
  parentStyleMap: Map<string, string> = new Map(),
  className: string = '',
  id: string = text,
): CSS2DObject {
  const label = document.createElement('div');
  label.className = 'label no-z-index';
  parentStyleMap.forEach((value, key) => label.style.setProperty(key, value));

  const labelChildDiv = document.createElement('div');
  labelChildDiv.className = className;
  labelChildDiv.id = id;
  labelChildDiv.textContent = text;
  styleMap.forEach((value, key) => labelChildDiv.style.setProperty(key, value));

  label.appendChild(labelChildDiv);
  const textObj = new CSS2DObject(label);
  textObj.layers.set(0);
  return textObj;
}

export function createConfigCodeUrl(
  code: string,
  baseUrl: string
): string {
  const parameters: string[] = location.search
    .slice(1) // remove the question mark at the beginning of the search string
    .split('&')
    .filter(p => p.includes('s=') || p.includes('scope=')); // remove all url parameters expect the scope

  return baseUrl + '?' + [...parameters, `c=${code}`].join('&');
}
